(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-drop-password"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sl-countdown')){customElements.define('sl-countdown',class extends HTMLElement{connectedCallback(){const raw=this.dataset.deadline;const end=Date.parse(raw);if(!/(Z|[+-]\d{2}:\d{2})$/.test(raw)||!Number.isFinite(end))return;const tick=()=>{const remaining=Math.max(0,Math.floor((end-Date.now())/1000));this.querySelector('.sl-clock').hidden=remaining===0;this.querySelector('[data-state]').hidden=remaining>0;if(!remaining){this.querySelector('[data-state]').textContent=this.querySelector('template').content.textContent;clearInterval(this.timer);return;}const units={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};for(const [key,value] of Object.entries(units))this.querySelector('[data-unit="'+key+'"]').textContent=String(value).padStart(2,'0');};this.timer=setInterval(tick,1000);tick();}disconnectedCallback(){clearInterval(this.timer);}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-drop-experience')) {
  customElements.define('sl-drop-experience', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.links = [...this.querySelectorAll('[data-look-link]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.links.forEach(link => link.addEventListener('click', event => { event.preventDefault(); this.activate(link.dataset.lookLink, true); }));
      this.querySelectorAll('[data-feature-look]').forEach(link => link.addEventListener('click', event => {
        const panel = this.panels.find(item => item.dataset.panel === link.dataset.featureLook);
        if (!panel) return;
        event.preventDefault();
        this.savedOnly = false;
        this.filterSaved();
        this.activate(panel.dataset.panel, true);
        panel.scrollIntoView({block: 'start', behavior: 'instant'});
        panel.setAttribute('tabindex', '-1');
        panel.focus({preventScroll: true});
      }));
      this.querySelectorAll('[data-save-look]').forEach(button => button.addEventListener('click', () => this.save(button)));
      this.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[data-panel]'); if (panel) this.activate(panel.dataset.panel, false); });
      this.querySelector('[data-saved-filter]').addEventListener('click', () => { this.savedOnly = !this.savedOnly; this.filterSaved(); });
      const linked = this.panels.find(panel => '#' + panel.id === location.hash);
      this.activate(linked?.dataset.panel || this.panels[0]?.dataset.panel, false);
      this.restore();
    }
    activate(id, updateUrl) {
      if (!id || !this.panels.some(panel => panel.dataset.panel === id)) return;
      this.panels.forEach(panel => { const active = panel.dataset.panel === id; panel.hidden = !active; panel.dataset.active = String(active); });
      this.links.forEach(link => { if (link.dataset.lookLink === id) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
      if (updateUrl) history.replaceState(null, '', '#' + this.panels.find(panel => panel.dataset.panel === id).id);
    }
    readSaved() { try { const value = JSON.parse(localStorage.getItem('screwloose-saved-looks') || '[]'); return Array.isArray(value) ? value.filter(item => typeof item === 'string').slice(0,50) : []; } catch { return []; } }
    restore() {
      const saved = this.readSaved();
      this.querySelector('[data-saved-count]').textContent = this.panels.filter(panel => saved.includes(panel.querySelector('[data-save-look]').dataset.saveLook)).length;
      this.querySelectorAll('[data-save-look]').forEach(button => { const active = saved.includes(button.dataset.saveLook); button.setAttribute('aria-pressed', String(active)); button.textContent = (active ? this.dataset.saved + ' ♥' : this.dataset.save + ' ♡'); });
    }
    filterSaved() {
      const saved = this.readSaved();
      const allowed = this.panels.filter(panel => !this.savedOnly || saved.includes(panel.querySelector('[data-save-look]').dataset.saveLook));
      this.querySelector('[data-saved-filter]').setAttribute('aria-pressed', String(Boolean(this.savedOnly)));
      this.querySelector('[data-saved-empty]').hidden = allowed.length > 0;
      this.links.forEach(link => { link.hidden = !allowed.some(panel => panel.dataset.panel === link.dataset.lookLink); });
      if (!allowed.some(panel => !panel.hidden)) {
        if (allowed.length) this.activate(allowed[0].dataset.panel, false);
        else this.panels.forEach(panel => { panel.hidden = true; });
      }
    }
    save(button) {
      const saved = this.readSaved();
      const key = button.dataset.saveLook;
      const next = saved.includes(key) ? saved.filter(item => item !== key) : [...saved, key];
      try { localStorage.setItem('screwloose-saved-looks', JSON.stringify(next)); this.restore(); this.filterSaved(); this.querySelector('[data-save-status]').textContent = (next.includes(key) ? this.dataset.saved : this.dataset.save) + ': ' + button.closest('[data-panel]').dataset.lookLabel; } catch { button.setAttribute('aria-pressed', 'false'); }
    }
  });
}

if (!customElements.get('sl-patch-loop')) {
  customElements.define('sl-patch-loop', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('button');
      if (!this.video || !this.toggle || this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.controls = false;
      this.video.muted = true;
      this.toggle.hidden = false;
      this.visible = false;
      this.sync = () => {
        const label = this.video.paused ? this.dataset.play : this.dataset.pause;
        this.toggle.textContent = label;
        this.toggle.setAttribute('aria-pressed', String(!this.video.paused));
      };
      this.toggle.addEventListener('click', () => {
        this.requested = this.video.paused;
        this.updatePlayback();
      }, options);
      this.video.addEventListener('play', this.sync, options);
      this.video.addEventListener('pause', this.sync, options);
      this.motion.addEventListener('change', () => { this.requested = undefined; this.updatePlayback(); }, options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.updatePlayback();
      }, {threshold: 0.25});
      this.observer.observe(this.video);
      this.sync();
    }
    updatePlayback() {
      const automatic = !this.motion.matches && !navigator.connection?.saveData;
      const wanted = this.requested ?? automatic;
      if (wanted && this.visible && !document.hidden) this.video.play().catch(() => this.sync());
      else this.video.pause();
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
      this.events = undefined;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-shop-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-shop-home')) {
  customElements.define('sl-shop-home', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open-set]');
        if (trigger) {
          const dialog = document.getElementById(trigger.dataset.openSet);
          if (!dialog?.showModal) return;
          event.preventDefault();
          dialog.showModal();
        }
        if (event.target.closest('[data-close-set]')) event.target.closest('dialog').close();
        if (event.target.tagName === 'DIALOG') {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }, {signal: this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); this.events = undefined; }
  });
}
if (!customElements.get('sl-patch-loop')) {
  customElements.define('sl-patch-loop', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('button');
      if (!this.video || !this.toggle || this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.controls = false;
      this.video.muted = true;
      this.toggle.hidden = false;
      this.visible = false;
      this.sync = () => {
        const label = this.video.paused ? this.dataset.play : this.dataset.pause;
        this.toggle.textContent = label;
        this.toggle.setAttribute('aria-pressed', String(!this.video.paused));
      };
      this.toggle.addEventListener('click', () => {
        this.requested = this.video.paused;
        this.updatePlayback();
      }, options);
      this.video.addEventListener('play', this.sync, options);
      this.video.addEventListener('pause', this.sync, options);
      this.motion.addEventListener('change', () => { this.requested = undefined; this.updatePlayback(); }, options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.updatePlayback();
      }, {threshold: 0.25});
      this.observer.observe(this.video);
      this.sync();
    }
    updatePlayback() {
      const automatic = !this.motion.matches && !navigator.connection?.saveData;
      const wanted = this.requested ?? automatic;
      if (wanted && this.visible && !document.hidden) this.video.play().catch(() => this.sync());
      else this.video.pause();
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
      this.events = undefined;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
